import {Box, Skeleton, Typography} from '@mui/material';
import type {ReactNode} from 'react';
import React from 'react';

export interface FieldProps {
    label: ReactNode;
    children?: ReactNode;
    loading?: boolean;
    skeletonWidth?: number | string;
    strong?: boolean;
    /** kein Wert → „—“ in gedämpfter Farbe */
    empty?: boolean;
}

export function Field({
                          label, children, loading, skeletonWidth = 120, strong, empty,
                      }: FieldProps) {
    return (
        <Box sx={{display: 'flex', alignItems: 'baseline', gap: 1.75, minHeight: 30}}>
            <Typography sx={{width: 150, flex: '0 0 auto', fontSize: 13.5, color: 'text.secondary'}}>
                {label}
            </Typography>
            {loading ? (
                <Skeleton variant="text" width={skeletonWidth} sx={{fontSize: 14}}/>
            ) : (
                <Typography
                    sx={{
                        fontSize: 14,
                        fontWeight: strong ? 600 : 400,
                        color: empty ? 'text.disabled' : 'text.primary',
                    }}
                >
                    {empty ? '—' : children}
                </Typography>
            )}
        </Box>
    );
}